import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, Avatar } from "@mui/material";
import * as EcommerceActions from '../../../redux/actions/ecommerceAction.js';
import { UploadImageSvg } from "../../../assets/svg/index.js";

const AddCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [categoryDetail, setCategoryDetail] = useState({ categoryName: '', tax: '' });
  const [inputFieldError, setInputFieldError] = useState({ categoryName: '', tax: '', image: '' });
  const [image, setImage] = useState({ file: '', bytes: '' });

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setCategoryDetail({ ...categoryDetail, [name]: value });
  };

  //! Handle Image : Normally
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  //! Handle Image : Drop Feature
  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.dataTransfer.files[0]),
        bytes: e.dataTransfer.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  //! Handle validation
  const handleValidation = () => {
    let isValid = true;
    const { categoryName, tax } = categoryDetail;
    const { bytes } = image;

    if (!categoryName) {
      handleInputFieldError("categoryName", "Please Enter Category Name")
      isValid = false;
    }
    if (!tax) {
      handleInputFieldError("tax", "Please Enter Tax")
      isValid = false;
    }
    if (!bytes) {
      handleInputFieldError("image", "Please Upload Image")
      isValid = false;
    }

    return isValid;
  };

  //! Handle Submit - Creating Category
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("Category Data :: ", { ...categoryDetail, image })
      const { categoryName, tax } = categoryDetail;

      let formData = new FormData()
      formData.append("title", categoryName)
      formData.append("tax", tax)
      formData.append("image", image?.bytes);

      const payload = {
        data: formData,
        onComplete: () => navigate("/e-commerce/category")
      }

      //! Dispatching API for Creating Banner
      dispatch(EcommerceActions.createEcommerceCategory(payload))
    }
  };

  return (
    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Ecommerce Category</div>
          <div onClick={() => navigate("/e-commerce/category")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item lg={12} sm={12} md={12} xs={12} >
            <div style={{ color: "#000", border: "1px solid #C4C4C4", borderRadius: "3px" }}>
              {image?.bytes ?
                <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", cursor: "pointer" }}>
                  <Avatar src={image.file} style={{ height: '300px', width: "300px", borderRadius: "initial" }} />
                </label>
                :
                <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", padding: "100px 0", cursor: "pointer" }}>
                  <UploadImageSvg h="80" w="80" color="#C4C4C4" />
                  <div style={{ fontWeight: "600", fontSize: "18px" }}>Choose Your Image to Upload</div>
                  <div style={{ fontWeight: "500", fontSize: "16px", color: 'grey' }}>Or Drop Your Image Here</div>
                </label>}
              <input id="upload-image" onChange={handleImage} hidden accept="image/*" type="file" />
            </div>
            {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10.75px", padding: "10px 0 0 12px", }}>{inputFieldError?.image}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Title" variant='outlined' fullWidth
              name='categoryName'
              value={categoryDetail?.categoryName}
              onChange={handleInputField}
              error={inputFieldError.categoryName ? true : false}
              helperText={inputFieldError.categoryName}
              onFocus={() => handleInputFieldError("categoryName", null)}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Tax (%)" type="number" variant='outlined' fullWidth
              name='tax'
              value={categoryDetail?.tax}
              onChange={handleInputField}
              error={inputFieldError.tax ? true : false}
              helperText={inputFieldError.tax}
              onFocus={() => handleInputFieldError("tax", null)}
            />
          </Grid>

          {/* <Grid item lg={6} sm={6} md={12} xs={12} >
            <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
              <Grid item xs={2} >
                <Avatar src={image.file} style={{ width: 40, height: 40 }} />
              </Grid>
              <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                Upload Category Image
                <input onChange={handleImage} hidden accept="image/*" type="file" />
              </Grid>
            </Grid>
            {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
          </Grid> */}

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div >
    </>
  );
};

export default AddCategory;